module.exports = __webpack_public_path__ + "static/img/就诊预约入口@2x.87d4f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/gjyxb/assets/ch/就诊预约入口@2x.png
// module id = 1486
// module chunks = 363